module.exports = new __parcel__URL__("bluejacket.21fd1f6d.jpg").toString();